import React, { useReducer, useEffect } from 'react'
import { storeToInstall, initialState } from './'
import QuizContext from './QuizContext'

function Quiz(props) {
  const [state, dispatch] = useReducer(storeToInstall, initialState)

  // useEffect(() => {
  //   console.log('- State:', state)

  //   if (!state.progress.quiz.completed && state.progess.quiz.location === 'summary') {
  //     props.saveData(state.progress)
  //   }

  // }, [state.progess])

  return (
    <QuizContext.Provider value={{
      loadedData: props.loadedData,
      saveData: props.saveData,
      goToRoute: props.goToRoute,
      goToModal: props.goToModal,
      state,
      dispatch,
    }}>
      <props.questionsComponent />

      {state.loaded ? props.children : 'Loading...'}
    </QuizContext.Provider>
  )
}

export default Quiz
